import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { HomePage } from '@/features/creators/dashboard/home/home-page';

const dashboardRoute = getRouteApi('/_auth/ixi-finance/creators_/dashboard');

// /ixi-finance/creators/dashboard — the Home tab. Everything on it comes from the
// dashboard layout's loader.
export const Route = createFileRoute('/_auth/ixi-finance/creators_/dashboard/')(
	{
		component: HomeRoute,
	},
);

function HomeRoute() {
	const { profile, home } = dashboardRoute.useLoaderData();
	return <HomePage profile={profile} home={home} />;
}
